// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.switch-comp-module__container___MpfMD {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

/* The switch - the box around the slider */
.switch-comp-module__switch___ckxQm {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 32px;
  margin-right: 16px;
}

/* Hide default HTML checkbox */
.switch-comp-module__switch___ckxQm input {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/* The slider */
.switch-comp-module__slider___rWHdB {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 34px;
  border: 2px solid var(--base, #f4f4f7);
  background-color: var(--surface1, #fff);
  transition: 0.4s;
}

.switch-comp-module__slider___rWHdB:before {
  position: absolute;
  content: "";
  height: 28px;
  width: 28px;
  left: 0;
  bottom: 0;
  background-color: var(--surface1, #fff);
  border-radius: 50%;
  transition: 0.4s;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.1490196078);
}

input:checked + .switch-comp-module__slider___rWHdB {
  background-color: var(--green300, #2b8000);
}

input:focus + .switch-comp-module__slider___rWHdB {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}

input:checked + .switch-comp-module__slider___rWHdB:before {
  transform: translateX(16px);
}

.switch-comp-module__state___uHXEu {
  font-size: 0.875rem;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/inputs/switch/switch-comp.module.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_focus-outline.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAMF;;AAHA,2CAAA;AACA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAMF;;AAHA,+BAAA;AACA;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AAMF;;AAHA,eAAA;AACA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,sCAAA;EACA,uCAAA;EACA,gBAAA;AAMF;;AAHA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AAMF;;AAHA;EACE,0CAAA;AAMF;;AAHA;ECxDI,wCAAA;EACA,mBAAA;AD+DJ;;AAJA;EACE,2BAAA;AAOF;;AAJA;EACE,mBAAA;EACA,gBAAA;AAOF","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../styles/utils.scss';\n\n.container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n/* The switch - the box around the slider */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 32px;\n  margin-right: 16px;\n}\n\n/* Hide default HTML checkbox */\n.switch input {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n/* The slider */\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 34px;\n  border: 2px solid color(base);\n  background-color: color(surface1);\n  transition: 0.4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: '';\n  height: 28px;\n  width: 28px;\n  left: 0;\n  bottom: 0;\n  background-color: color(surface1);\n  border-radius: 50%;\n  transition: 0.4s;\n  box-shadow: 0px 3px 8px 0px #00000026;\n}\n\ninput:checked + .slider {\n  background-color: color(green300);\n}\n\ninput:focus + .slider {\n  @include focus-outline($applyDirectly: true);\n}\n\ninput:checked + .slider:before {\n  transform: translateX(16px);\n}\n\n.state {\n  font-size: rem(14);\n  font-weight: 400;\n}\n","@import '../functions/color';\n\n@mixin focus-outline($color: color(focus), $applyDirectly: false) {\n  @if $applyDirectly {\n    outline: $color solid 2px;\n    outline-offset: 3px;\n  } @else {\n    &:focus {\n      outline: $color solid 2px;\n      outline-offset: 3px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `switch-comp-module__container___MpfMD`,
	"switch": `switch-comp-module__switch___ckxQm`,
	"slider": `switch-comp-module__slider___rWHdB`,
	"state": `switch-comp-module__state___uHXEu`
};
export default ___CSS_LOADER_EXPORT___;
